/**
 * UI Constants
 *
 * This file contains all UI element sizes and styles
 * used throughout the application to maintain consistency.
 */

export const NAV_PANEL = {
    EXPANDED: {
        WIDTH: 250,
    },
    COLLAPSED: {
        WIDTH: 60,
    },
} as const;

export const TRANSMISSION_INSIGHTS_CHARTS_PANEL = {
    WIDTH: 400,
} as const;

export const TRANSMISSION_INSIGHTS_DATA_TABLE = {
    HEIGHT: 325,
    MIN_WIDTH: 450,
} as const;

export const TRANSMISSION_INSIGHTS_MAP = {
    MIN_WIDTH: 450,
    MIN_HEIGHT: 450,
} as const;

// Custom scrollbar styles
export const SCROLLBAR_STYLE = `
.custom-scrollbar .os-scrollbar-handle {
    background: #C6C5C5 !important;
    border-radius: 4px !important;
}
.custom-scrollbar .os-scrollbar-handle:hover {
    background: #535353 !important;
}
.dark .custom-scrollbar .os-scrollbar-handle {
    background: #7A8690 !important;
}
.dark .custom-scrollbar .os-scrollbar-handle:hover {
    background: #CEE0EF !important;
}
`;

